// Radix copies the content's computed z-index onto the popper wrapper it positions, so stacking
// belongs here rather than at each call site. In the top layer z-index is moot; without Popover API
// support `z-50` clears what a panel can meet: the dialog close button and sticky content inside a
// modal, and sticky page headers outside one.
//
// The top layer changes where the panel paints, not where it sits in the DOM, so it still inherits
// text properties from the trigger's ancestors: a trigger in a `whitespace-nowrap` cell would
// otherwise stop the panel's own text from wrapping.
export const TOOLTIP_CONTENT_CLASS =
    'z-50 whitespace-normal rounded-lg bg-[#ffe6c8] p-4 shadow-[0_2px_10px_0_#0000001a]'

export const TOOLTIP_ARROW_CLASS = 'fill-[#ffe6c8]'

// Zero-size and fixed so it takes no layout space next to the trigger; the panel inside it is
// positioned against the viewport by Radix.
export const TOOLTIP_PORTAL_CONTAINER_CLASS = 'fixed left-0 top-0 size-0 overflow-visible'
